import { render } from "./CreatePassword.vue?vue&type=template&id=01f29139&scoped=true"
import script from "./CreatePassword.vue?vue&type=script&lang=js"
export * from "./CreatePassword.vue?vue&type=script&lang=js"

import "./CreatePassword.vue?vue&type=style&index=0&id=01f29139&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f29139"]])

export default __exports__